/* eslint-disable */
export default {
  recentActivities: '最近的活动',
  text: '短信',
  fax: '传真',
  voicemail: '语音邮件',
  call: '电话',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
